/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

/* ================ SLATE ================ */
// Please note, this theme was NOT built with Slate.
// It's been retrofitted for sections using some of 
// the Slate code as a base. More code at bottom of file.
window.slate = window.slate || {};
window.theme = window.theme || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.utils = {
  /**
   * Turns a string into a handle. Mimics Shopify's format.
   */
  handleize: function(str) {
    return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
  },

  /**
   * Cross-browser URL query param getter
   */
  getQueryParams: function(qs) {
    if (!qs) { 
      if (document.location.search) {
        qs = document.location.search;
      } else {
        return;
      }
    }

    qs = qs.split('+').join(' ');

    var params = {},
        tokens,
        re = /[?&]?([^=]+)=([^&]*)/g;

    while (tokens = re.exec(qs)) {
      params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    }

    return params;
  },
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '$';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format || '');

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    if (formatString.match(placeholderRegex) == null){
      // console.log(cents);
      value = formatWithDelimiters(cents, 2);
      return '$' + value;
    } else {
      switch(formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $('body'),

    // Navigation
    $navigation              : $('#AccessibleNav'),
    $mobileSubNavToggle      : $('.mobile-nav__toggle'),
    $mobileChildNavToggle    : $('.mobile-child-nav__toggle'),
    $navDrawer               : $('#NavDrawer'),
    $mobileSearchTrigger     : $('.mobile-search-trigger'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('#ProductPhotoImg'),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  };
};

timber.init = function () {
//   FastClick.attach(document.body);
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.drawersInit();
  timber.mobileNavToggle();
  timber.mobileChildNavToggle();
  timber.mobileSearchTrigger();
  timber.productImageSwitch();
  timber.responsiveVideos();
//   timber.collectionViews();
  timber.loginForms();
};

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.drawersInit = function () {
  timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');

};

timber.mobileNavToggle = function () {
  timber.cache.$mobileSubNavToggle.on('click', function(e) {
    e.preventDefault();
    $(this).parent().toggleClass('mobile-nav--expanded');
    $(this).parent().parent().toggleClass('active');
    if ($('.mobile-nav__has-sublist.mobile-nav--expanded').length) {
      timber.cache.$navDrawer.addClass('sublist-is-open');
    } else {
      timber.cache.$navDrawer.removeClass('sublist-is-open');
    }
  });
};

timber.mobileChildNavToggle = function () {
  timber.cache.$mobileChildNavToggle.on('click', function() {
    $(this).toggleClass('mobile-nav--expanded');
  });
};

timber.mobileSearchTrigger = function () {
  timber.cache.$mobileSearchTrigger.on('click', function() {
    window.setTimeout(function(){
      $('#NavDrawer input[type="search"]').focus();
    }, 750);
  });
};

timber.getHash = function () {
  return window.location.hash;
};

timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText');

  if (variant) {

    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0];
      Shopify.Image.switchImage(newImg, el, timber.switchImage);
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html($addToCartText.data('button-text'));
      $quantityElements.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html("Coming Soon");
      $quantityElements.hide();
    }

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html("RRP" + ' ' + Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Select Size");
    $quantityElements.hide();
  }
};

timber.productImageSwitch = function () {
  if (timber.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      timber.switchImage(newImage, null, timber.cache.$productImage);
    });
  }
};

timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
};

timber.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};

/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus(this.$drawer, 'drawer_focus');

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$nodes.moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, 'drawer_focus');

    this.$nodes.page.off('.drawer');
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');

    $container.focus();

    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();

// Initialize Timber's JS on docready
$(timber.init);

/* ================ SLATE ================ */
// Please note, this theme was NOT built with Slate. It's been retrofitted for sections using some of the Slate code as a base. More code at top of file.

window.theme = window.theme || {};

theme.contentSliders = (function() {
  this.$contentSlider = null;

  var config = {
    mediaQuerySmall: 'screen and (max-width: 767px)',
    mediaQueryMediumUp: 'screen and (min-width: 768px)'
  };

  function contentSliders(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var wrapper = this.wrapper = '.content-slider-wrap';
    var slider = this.slider = '#content-slider-' + sectionId;
    var $slider = $(slider, wrapper);
    var sliderActive = false;

    var options = {
      loop: $slider.data('infinite'),
      slidesPerView: $slider.data('slides-show-desktop'),
      slidesPerGroup: $slider.data('slides-scroll-desktop'),
      breakpoints: {
        992: {
          slidesPerView: $slider.data('slides-show-tablet'),
          slidesPerGroup: $slider.data('slides-scroll-tablet')
        },
        768: {
          slidesPerView: $slider.data('slides-show-tablet'),
          slidesPerGroup: $slider.data('slides-scroll-tablet')
        },
        580: {
          slidesPerView: $slider.data('slides-show-tablet'),
          slidesPerGroup: $slider.data('slides-scroll-tablet')
        }
      }
    };

    if ($slider.data('autoplay')) {
      options.autoplay = {
        delay: $slider.data('speed'),
      };
    }

    if ($slider.data('dots')) {
      options.pagination = {
        el: '.swiper-pagination',
        type: 'bullets',
      };
    } else {
      options.pagination = false;
    }

    if ($slider.data('arrows')) {
      options.navigation = {
        nextEl: slider + ' ~ .content-slider__next',
        prevEl: slider + ' ~ .content-slider__prev',
      };
    } else {
      options.navigation = false;
    }

    if ($slider.data('arrows-mobile')) {
      options.breakpoints[768].navigation = {
        nextEl: slider + ' ~ .content-slider__next',
        prevEl: slider + ' ~ .content-slider__prev',
      };
      options.breakpoints[580].navigation = {
        nextEl: slider + ' ~ .content-slider__next',
        prevEl: slider + ' ~ .content-slider__prev',
      };
    } else {
      options.breakpoints[768].navigation = false;
      options.breakpoints[580].navigation = false;
    }

    if ($slider.data('dots-mobile')) {
      options.breakpoints[768].pagination = {
        el: '.swiper-pagination',
        type: 'bullets',
      };
      options.breakpoints[580].pagination = {
        el: '.swiper-pagination',
        type: 'bullets',
      };
    } else {
      options.breakpoints[768].pagination = false;
      options.breakpoints[580].pagination = false;
    }

    if ($slider.data('autoplay-mobile')) {
      options.breakpoints[768].autoplay = {
        delay: $slider.data('speed'),
      };
      options.breakpoints[580].autoplay = {
        delay: $slider.data('speed'),
      };
    }

    initSlider($slider, options);

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        this.$contentSlider.destroy(true, true);
        sliderActive = false;
      }

      this.$contentSlider = new Swiper(sliderObj, args);
      sliderActive = true;
    }
  }

  contentSliders.prototype = _.assignIn({}, contentSliders.prototype, {
    onUnload: function() {
      $(this.$contentSlider).destroy(true, true);
    }
  });

  return contentSliders;
})();

window.theme = window.theme || {};

theme.featuredCollections = (function() {
  this.$featuredCollection = null;

  var config = {
    mediaQuerySmall: 'screen and (max-width: 767px)',
    mediaQueryMediumUp: 'screen and (min-width: 768px)'
  };

  function featuredCollections(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var wrapper = this.wrapper = '.featured-collection';
    var slider = this.slider = '#featured-collection-' + sectionId;
    var $slider = $(slider, wrapper);
    var sliderActive = false;

    var options = {
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        hide: false
      },
      loop: false,
      navigation:{
            nextEl:".swiper-button-next",
            prevEl:".swiper-button-prev"
      },
      slidesPerView: 4,
      spaceBetween: 10,
      breakpoints: {
        1024: {
          slidesPerView: 3
        },
        768: {
          slidesPerView: 3
        },
        620: {
          spaceBetween: 0,
          slidesPerView: 2
        }
      }
    };

    if ($slider.data('autoplay')) {
      options.autoplay = {
        delay: $slider.data('speed'),
      };
    }

    if ($slider.data('autoplay-mobile')) {
      options.breakpoints[768].autoplay = {
        delay: $slider.data('speed'),
      };
      options.breakpoints[620].autoplay = {
        delay: $slider.data('speed'),
      };
    }

    initSlider($slider, options);

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        this.$featuredCollection.destroy(true, true);
        sliderActive = false;
      }

      this.$featuredCollection = new Swiper(sliderObj, args);
      sliderActive = true;
    }
  }

  featuredCollections.prototype = _.assignIn({}, featuredCollections.prototype, {
    onUnload: function() {
      $(this.$featuredCollection).destroy(true, true);
    }
  });

  return featuredCollections;
})();

var tag = document.createElement('script');tag.src = "https://www.youtube.com/iframe_api";var firstScriptTag = document.getElementsByTagName('script')[0];firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

$(document).ready(function() {
  var sections = new theme.Sections();
  sections.register('content-slider', theme.contentSliders);
  sections.register('featured-collection', theme.featuredCollections);

  $('.promo-slider__element').each(function(){
    var $this = $(this);
    var $slides = $this.find('.swiper-slide');
    var nextEl = $this.find('.swiper-button-next');
    var prevEl = $this.find('.swiper-button-prev');
    var paginationEl = $slides.length > 1 ? $this.find('.swiper-pagination') : false;
    var options = {
      slidesPerView: 1,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      loop: true,
      autoHeight: true,
      threshold: 20,
      preloadImages: false,
      observer: true,
      loopedSlides: $slides.length,
      preventClicks: false,
      on: {
        init: function () {
          var $slider = $(this)[0].$el;
          $slider.find('.swiper-slide-duplicate .lazyloading').removeClass('lazyloading').addClass('lazyload lazypreload');
          if ($(window).width() < 600) {
            $slider.find('.swiper-slide-next .lazyload.promo-slide__image-small').addClass('lazypreload');
          } else {
            $slider.find('.swiper-slide-next .lazyload:not(.promo-slide__image-small)').addClass('lazypreload');
          }
          this.update();
        },
        slideChangeTransitionStart: function() {
          var isVideo = this.slides[this.activeIndex].querySelector('.video-container');
          if (isVideo && typeof YT !== "undefined" && YT !== undefined) {
            YT.get(isVideo.querySelector('iframe').id).playVideo()
          }
        },
        slideChangeTransitionEnd: function() {
          var isVideo = this.slides[this.previousIndex].querySelector('.video-container');
          if (isVideo && typeof YT !== "undefined" && YT !== undefined) {
            YT.get(isVideo.querySelector('iframe').id).pauseVideo()
          }
        },
        slideChange: function () {
          var $slider = $(this)[0].$el;
          if ($(window).width() < 600) {
            $slider.find('.swiper-slide-next .lazyload.promo-slide__image-small').addClass('lazypreload');
          } else {
            $slider.find('.swiper-slide-next .lazyload:not(.promo-slide__image-small)').addClass('lazypreload');
          }
        }
      },
      pagination: {
        el: paginationEl,
        type: 'bullets',
        clickable: true
      }
    };

    if (this.dataset.autoplay && $slides.length > 1) {
      options.autoplay = { delay: this.dataset.delay };
    }
    
    if ($slides.length <= 1) {
      options.allowTouchMove = false;
    }

    var mySwiper = new Swiper(this, options);
  });

  var onPlayerReady = function (event){event.target.mute();event.target.playVideo();}
  var onPlayerStateChange = function (event){if(event.data === YT.PlayerState.ENDED){event.target.playVideo();}}

  var initPlayer = function(element) {
    var player = element.querySelector('.video-iframe');
    var button = element.querySelector('.video-play');
    var ytplayer = new YT.Player(player, {
      playerVars: {
        'autoplay': 1,
        'autohide': 1,
        'showinfo': 0,
        'modestbranding': 1,
        'controls': 0,
        'rel': 0,
        'loop': 1,
        'volume': 0,
        'wmode': 'opaque',
        'origin': 'https://www.ultrafootball.com',
      },
      width: '100%',
      height: player.dataset.height + '%',
      events: {
        'onReady': onPlayerReady,
        'onStateChange': onPlayerStateChange
      },
      videoId: element.dataset.id
    });

    button.addEventListener('click', function() {
      switch (ytplayer.getPlayerState()) {
        case 1:
          ytplayer.pauseVideo();
          break;
        default:
          ytplayer.playVideo();
          break;
      }
    })
  }

  window.onYouTubeIframeAPIReady = function() {
    var container = document.querySelectorAll('.video-container');
    for (var i = 0; i < container.length; i++) {
      initPlayer(container[i])
    }
  }

  // Grid Item Sibling Colour Swatches
  var $relatedSwatches = $('.related_swatches');
  if ($relatedSwatches.length) {
    var currentProductId = $relatedSwatches.data('current-product');
    var siblingSku = $relatedSwatches.data('sibling-sku');
    var relatedSwatchSource = document.getElementById('related-swatch-template').innerHTML;
    var relatedSwatchTemplate = Handlebars.compile(relatedSwatchSource);
    $.get('/collections/all/' + siblingSku + '?view=json', function(response){
      var relatedProducts = JSON.parse(response);
      
      for (var i = 0; i < relatedProducts.length; i++) {
        if (currentProductId != relatedProducts[i].id) {
          var relatedSwatchContext = {url: relatedProducts[i].url, image: relatedProducts[i].featured_image};
          var relatedSwatchHtml = relatedSwatchTemplate(relatedSwatchContext);
          theme.sliders.relatedSwatches.appendSlide(relatedSwatchHtml);
        }
      }
      $relatedSwatches.addClass('related_swatches--loaded');
    });
  }

  // Collection Filter View More Buttons
  $('.filter-group ul').each(function(){
    var $children = $(this).children();
    if ($children.length > 10 && !$(this).is('.size-filter ul')) {
      var childHeight = $children.first().outerHeight();
      $(this).css({
        height: (childHeight * 10) + 'px',
      });
      // $(this).data('expanded-height', (childHeight * $children.length) + 'px');
      $(this).addClass('filter-group-list--has-view-more');
      $(this).append('<span class="filter-group__view-more">View More <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-fa-caret-down" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1408 704q0 26-19 45l-448 448q-19 19-45 19t-45-19L403 749q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45z"/></svg></span>');
    }
  });

  $('.filter-group__view-more').on('click', function() {
    $(this).parent().addClass('filter-group-list--expanded').removeClass('filter-group-list--has-view-more');
  });

  var $currentCollectionFilters = $('.collection-container.active.selected');
  if ($currentCollectionFilters.length) {
    var appendString = '', elementString;
    $currentCollectionFilters.each(function(){
      elementString = $(this).html();
      if (elementString.indexOf('/collections/all') <= -1) {
        appendString += elementString;
      }
    });

    if (appendString != '') {
      $('.refine-header').before('<div class="refine-current"><h5>Your Selection</h5>' + appendString + '</div>');
    }
  }

  $('.wholesale-product-form input[data-variant-id]').on('blur', function(){
    var val = parseInt($(this).val());
    var max = parseInt($(this).data('max'));
    if (val > max) {
      $(this).val(max);
    } else if (!val || val < 0) {
      $(this).val(0);
    }
  });

  $('.wholesale-product-form__submit').on('click', function(e){
//     e.preventDefault();
    
    var $this = $(this);
    $this.addClass('loading');

    var $inputs = $(this).parent().find('input[data-variant-id]');
    var formHasQty = false;
    $inputs.each(function(){
      var qty = parseInt($(this).val());
      var variantId = $(this).data('variant-id');
      if (variantId && qty > 0) {
        formHasQty = true;
        var lineitem = [{ variant_id: variantId, quantity: qty }];
        ShopifyAPI.cartQueue.push.apply(ShopifyAPI.cartQueue, lineitem);
      }
    });

    if (formHasQty) {
      ShopifyAPI.afterQueue = function(){
        $this.removeClass('loading');
        var $drawer = $('#CartDrawer');
        if (!$drawer.hasClass('open')) {
          $drawer.addClass('open');
          setTimeout(function() {
            $drawer.removeClass('open');
          }, 3000);
        }
      }

      ShopifyAPI.processQueue();
    } else {
      $this.removeClass('loading');
      
      var buttonText = $this.text();
      $this.text('Please select quantity');

      window.setTimeout(function(){
        $this.text(buttonText);
      }, 2500);
    }
  });
  
  // Club Zone Landing Page
  (function($) {
    var selectors = {
      registerLightbox: '#club-zone-register-modal',
      registerFailure: '#club-zone-register-failure',
      registerSuccess: '#club-zone-register-success',
      loginLightbox: '#club-zone-login-modal',
      loginFailure: '#club-zone-login-failure',
      loginSuccess: '#club-zone-login-success',
    };

    var $registerSuccess = $(selectors.registerSuccess);
    if ($registerSuccess.length) {
      $.fancybox($registerSuccess, lightboxOptions);
    }

    var $registerFailure = $(selectors.registerFailure);
    if ($registerFailure.length) {
      $.fancybox($registerFailure, lightboxOptions);
    }

    var $loginSuccess = $(selectors.loginSuccess);
    if ($loginSuccess.length) {
      $.fancybox($loginSuccess, lightboxOptions);
    }

    var $loginFailure = $(selectors.loginFailure);
    if ($loginFailure.length) {
      $.fancybox($loginFailure, lightboxOptions);
    }
  })(jQuery);

  (function($) {
    var $clubZoneSelects = $('.club-zone-select');
    if ($clubZoneSelects.length && typeof $.fn.selectize === "function") {
      $clubZoneSelects.selectize({
        valueField: 'url',
        labelField: 'name',
        searchField: 'name',
        dataAttr: 'data-json',
        create: false,
        render: {
          item: function(item, escape) {
            return "<div><img class='club-logo-badge club-logo-badge-" + escape(item.url) + "' />&nbsp;" + escape(item.name) + "</div>";
          },
          option: function(item, escape) {
            return "<div><span class='club-logo-badge club-logo-badge-" + escape(item.url) + "' />&nbsp;" + escape(item.name) + "</div>";
          }
        },
        onChange: function(value) {
          var $img = this.$control.find('img');
          $.getJSON('/collections/' + value, function(response){
            var collection = response.collection;
            if (collection && collection.image.src) {
              $img.attr('data-src', slate.Image.getSizedImageUrl(collection.image.src, '{width}x')).attr('data-sizes', 'auto').addClass('lazyload');
            }
          });

          var $tagsElem = $('#customer_tags');
          if (value == 'no-club' || value == '') {
            $tagsElem.val('');
          } else {
            $tagsElem.val('club-zone,tier-platinum,' + value);
          }
        },
        onDropdownOpen: function($dropdown) {
          $dropdown.closest('.fancybox-inner').css('overflow', 'visible');
        },
        onDropdownClose: function($dropdown) {
          $dropdown.closest('.fancybox-inner').css('overflow', 'auto');
        },
        onInitialize: function($dropdown) {
          var queryParams = theme.utils.getQueryParams();
          if (queryParams !== undefined && queryParams.club !== undefined) {
            if (this.options[queryParams.club] !== undefined) {
              this.setValue(this.options[queryParams.club]["url"]);
            }
          }
        },
        load: function(query, callback) {}
      });
    }
  })(jQuery);
  
  $(document).on('click', '.update-customer-club', function(){
    var selectize = $(this).siblings('.club-zone-select')[0].selectize;
    var club = selectize.items[0];

    $(this).addClass('loading');

    $.ajax({
      type: "POST",
      beforeSend: function(request) {
        request.setRequestHeader("X-CAT", selectize.options[club].id);
        request.setRequestHeader("X-CZF", shop.customer.club);
        request.setRequestHeader("X-CZT", club);
        request.setRequestHeader("X-CID", shop.customer.id);
      },
      url: "https://do.positionrelative.net/helpers/ultra/update-customer-club.php",
      success: function(customer) {
        if (customer.tags.indexOf(club) > -1 || club == 'no-club') {
          window.scrollTo(0,0);
          window.location.reload();
        }
      }
    });
  });

  // Modals
  $(document).on('click', '.modal-trigger', function(evt) {
//     evt.preventDefault();

    var modalSelector = this.dataset.modal || this.hash || false;
    
    if (!modalSelector) {
      return;
    }
    
    if ($.fancybox !== undefined) {
      $.fancybox.close();
      
      var modalOptions = {
        padding: 0,
        wrapCSS: 'ultra-modal',
        helpers:  {
          overlay : {
            css : {
              'background' : 'rgba(0,0,0,0.5)'
            }
          }
        }
      };

      $.fancybox($(modalSelector), modalOptions);
    }
  });

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function(evt) {
    evt.preventDefault();
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  objectFitImages();

  if ($.tabs !== undefined && $( "#tabs" ).length) {
    $( "#tabs" ).tabs();
  }

  if ($('.account-tabs-menu').length) {
    $('.account-tabs-menu a').click(function(event) {
      event.preventDefault();
      $(this).parent().addClass("current");
      $(this).parent().siblings().removeClass("current");
      var tab = $(this).attr("href");
      $(".tab-content").not(tab).css("display", "none");
      $(tab).fadeIn();
      window.history.pushState(tab, tab, $(this).attr("id").replace('btn-','#'));
    });

    if (window.location.hash) {
      var activeTab = window.location.hash.replace('#','#btn-');
      $(activeTab).click();
    }
  }
});

// copa page - click arrow links to next section
$(function(){
  $(".copa-arrow a").on('click', function(event){
    if (this.hash !== ""){
      event.preventDefault();
      var hash = this.hash;
      $('html, body').animate({
      	scrollTop: $(hash).offset().top
      }, 800, function(){
      	window.location.hash = hash;
     });
    }
  });
});
 
$('.js-drawer-open-left').click(function() {
	$(".filter-menu--wrapper").removeClass("sticky-filter-menu--wrapper");
});

$(function () {
	var accordions = $( "#accordion-footer-one,#accordion-footer-two,#accordion-footer-three,#accordion-footer-four,#accordion-footer-five" ).accordion({
		collapsible: true,
		active:false,
        heightStyle:"content",
        beforeActivate: function(event, ui) {
        	accordions.not(this).accordion('option', 'active', false);
        }
	}); 
});

$(function () {
  	var currentYear = new Date().getFullYear();
	$("#spanDate").text(new Date().getFullYear());
});

// Flickity
$(document).ready(function(){
    $('.feature-button-tiles-carousel').flickity({
        autoPlay: false,
        cellAlign: 'center',
        contain: true,
        wrapAround: true,
      	pageDots: false,
      	imagesLoaded: true,
      	lazyLoad: true,
      	bgLazyLoad: true,
        draggable: true,
        dragThreshold: 2
    });
});

$(document).ready(function(){
    $('.feature-buttons-carousel-wrapper').flickity({
        autoPlay: 7000,
        cellAlign: 'center',
        contain: true,
        wrapAround: true,
      	pageDots: false,
      	imagesLoaded: true,
      	lazyLoad: true,
      	bgLazyLoad: true,
        draggable: true,
        dragThreshold: 2
    });
});

$(document).ready(function(){
    $('.launch-zone-carousel.feature-buttons-carousel-wrapper').flickity({
        autoPlay: 7000,
        cellAlign: 'center',
        contain: true,
        wrapAround: true,
      	pageDots: false,
      	imagesLoaded: true,
      	lazyLoad: true,
      	bgLazyLoad: true,
      	autoplay: true,
        draggable: true,
        dragThreshold: 2
    });
});

$(document).ready(function(){
    $('.feature-buttons-carousel-expanded').flickity({
        autoPlay: 7000,
        cellAlign: 'left',
        verticalCells: true,
        contain: true,
        wrapAround: true,
      	pageDots: true,
      	imagesLoaded: true,
      	lazyLoad: true,
      	bgLazyLoad: true,
        draggable: true,
        dragThreshold: 2     
    });
});

// sticky add to cart PP
$(window).on("scroll", function() {
    const scrollTop = document.body.scrollTop,
        docElement = document.documentElement.scrollTop,
        elementReached = 1200,
        container = $(".sticky-button-container"),
        button = $("#stickyButton")

    if (scrollTop > elementReached || docElement > elementReached) {
        button.fadeIn('fast')
        container.fadeIn('fast')
        button.style.display = "block"
        container.style.display = "block"
    } else {
        button.fadeOut('fast')
        container.fadeOut('fast')
    }
});

$(document).ready(function(){
  document.getElementById("stickyButton").addEventListener("click", function(){
      document.querySelector(".add-ons-container").scrollIntoView();	
  });
});

$(document).ready(function(){
  
  var session_referal_tag = "boot-finder-iframe";
  var referal_storage = JSON.parse(sessionStorage.getItem("referal"));

  if(referal_storage.tag == session_referal_tag){
    $('#bootFinder').attr({
      name: "properties[Referral ]",
      value: "Boot Finder"
    });
  }
  
});